import parsePhoneNumberFromString, { CountryCode, PhoneNumber } from 'libphonenumber-js';
import { Injectable } from '@angular/core';
import { IPhoneNumberInfo } from '@nimbus-library/features/shared/services/helper/i-phone-number.info';

@Injectable({ providedIn: 'root' })
export class PhoneNumberService {
  public normalizeNumber(input: string, internalExtensionLength: number = 4, defaultCountry: CountryCode = 'US'): IPhoneNumberInfo {
    if (input.length <= internalExtensionLength) {
      return {
        countryCode: null,
        isValid: true,
        phoneNumber: input,
        originalNumber: input,
      };
    }

    let phoneNumber: PhoneNumber;
    try {
      phoneNumber = parsePhoneNumberFromString(input, defaultCountry);
    } catch (ex) {
      return {
        countryCode: null,
        isValid: false,
        phoneNumber: input,
        originalNumber: input,
      };
    }

    return {
      countryCode: phoneNumber ? phoneNumber.country : null,
      isValid: phoneNumber ? phoneNumber.isValid() : false,
      phoneNumber: phoneNumber ? phoneNumber.format('E.164') : input,
      originalNumber: input,
    };
  }
}
